// src/components/Skills.js

import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills } from "../data";

export default function Skills() {
    return (
        <section id="skills" className="text-stone-900 bg-sky-50 body-font">
        <div className="container px-5 py-10 mx-auto">
          <div className="text-center mb-20">
            <ChipIcon className="w-16 inline-block mb-4" />
            <h1 className="sm:text-4xl text-3xl font-medium title-font text-stone-900 mb-4">
              Technologies
            </h1>
            <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
              Our vision is to apply the same everyday Internet technologies (e.g. protocols, routing, security) to network edge devices while working with their inherent constraints 
              (e,g, hardware resources, bandwidth, range, interference, battery life). 
            </p>
          </div>
          <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
            {skills.map((skill) => (
              <div key={skill} className="p-2 sm:w-1/2 w-full">
                <div className="bg-green-700 rounded flex p-4 h-full items-center">
                  <BadgeCheckIcon className="text-white w-6 h-6 flex-shrink-0 mr-4" />
                  <span className="title-font font-medium text-white">
                    {skill}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        </section>
    )
}

// repeat the same basic structure for all 6 components


// WEBPACK FOOTER //
// ./src/components/Skills.js